import AbstractApi, { Method } from "@/Core/api/AbstractApi"
import { AxiosPromise } from "axios"
import { Marketer } from "../../models"

const CORE_URL = process.env.VUE_APP_CORE_URL

const Path = {
  Main: `${CORE_URL}/config-marketer-account`,
}

class MarketersSingleton extends AbstractApi{
  private static _instance: MarketersSingleton
  private constructor() { super() }

  public static get instance(): MarketersSingleton {
    if (!MarketersSingleton._instance) MarketersSingleton._instance = new MarketersSingleton();
    return MarketersSingleton._instance;
  }


  public getAll(): AxiosPromise<Marketer[]> {
    return this.request({
      method: Method.GET,
      url: Path.Main,
    })
  }

  public create(data: Marketer): AxiosPromise<Marketer> {
    return this.request({
      method: Method.POST,
      url: Path.Main,
      data
    })
  }

  public update(data: Marketer): AxiosPromise<Marketer> {
    return this.request({
      method: Method.PATCH,
      url: `${Path.Main}/${data.id}`,
      data
    })
  }

  public delete(id: string): AxiosPromise<Marketer> {
    return this.request({
      method: Method.DELETE,
      url: `${Path.Main}/${id}`
    })
  }
}

export const MarketersApi = MarketersSingleton.instance